import Util from "@/Master/Util";
import EventManager from "@/Fwk/EventManager";
import { masterEvent } from "@/Master/Const/MasterEvent";
import FrameOrientMgr from "@/Master/FrameOrientMgr";
import KitPwa from "@/Master/PWA/KitPwa";
import UtilBrowser from "@/Master/UtilBrowser";
import { confJson } from "@/app/config/confJson";
import SdkMgr from "@/Fwk/SDK/SdkMgr";
import DuMgr from "@/Fwk/SM/DuMgr";

import sdkHeaderJson from "./SdkHeader.json";
import {GameInitConfig} from "@/Core/Bridge/UnityConfig";
import {CallJSSKey} from "@/Core/Bridge/CallJSSKey";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {updateUnityBar} from "@/app/(game)/unity-game/unityBarUtil";
import KitAPI from "@/Fwk/Kit/KitAPI";
import CallTempData from "@/Core/Bridge/CallTempData";
import RouterMgr from "@/Core/RouterMgr";
import BigTips from "@/Master/BigTips";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import {GameMsgKey} from "@/app/(game)/GameMsgKey";

// 定义与 Unity 交互的消息接口
interface UnityMessage {
    key: string;
    strValue: string;
    intValue: number;
}

export default class CallJSS {
    static tag: string = `[CallJSS]`;

    /**
     * 封装日志输出，统一管理日志格式和开关
     * @param message 日志消息
     */
    private static log(message: string, ...optionalParams: any[]) {
        if (Util.isLog) {
            console.log(this.tag, message, ...optionalParams);
        }
    }

    /**
     * 初始化 CallJSS，设置可见性变化监听器
     */
    static Init(): void {
        this.log('Hello');

        // 初始化 SDK 管理器
        SdkMgr.Init();

        // 设置页面可见性变化的监听器
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        document.addEventListener("resize", this.onResize);
    }

    /**
     * 游戏初始化方法
     */
    static GameInit(): void {
        this.log('Hello GameInit');
        // 在此处添加游戏初始化逻辑
    }

    private static onResize(){
        this.On(CallJSSKey.LayoutRefresh, 'onResize', 0);
    }

    /**
     * 处理可见性变化事件
     */
    private static handleVisibilityChange = (): void => {
        if (document.visibilityState === "hidden") {
            this.On(CallJSSKey.OnDocumentHidden, 'data', 0);
            this.log(`onDocumentHidden`);
            EventManager.dispatchEvent(masterEvent.onVisibilitychangeHide);
        } else {
            this.On(CallJSSKey.OnDocumentVisible, 'data', 0);
            this.log(`onDocumentVisible`);
            setTimeout(() => {
                GameMsgUtil.sendMsgParent({
                    type: GameMsgKey.game_frame_orient_update,
                })
            });
            let count = 0;
            const updateInter = setInterval(() => {
                count++;
                GameMsgUtil.sendMsgParent({
                    type: GameMsgKey.game_frame_orient_update,
                })
                if (count > 3) {
                    clearInterval(updateInter);
                }
            }, 100);

            EventManager.dispatchEvent(masterEvent.onVisibilitychangeShow);
        }
    };


    /**
     * 发送消息到 Unity
     * @param key 消息 key
     * @param strValue 字符串值
     * @param intValue 整数值
     */
    static On(key: CallJSSKey, strValue: string, intValue: number): void {
        this.log(`On => key=${key}, strValue=${strValue}, intValue=${intValue}`);

        if (window.unityInstance) {
            const message: UnityMessage = { key, strValue, intValue };
            const jsonStr = JSON.stringify(message);
            this.log(`On => SendMessage('WebGLBridge', 'CallUnity', ${jsonStr})`);
            window.unityInstance.SendMessage('WebGLBridge', 'CallUnity', jsonStr);
        }
    }

    /**
     * 执行特定操作
     * @param key 操作 key
     * @param intVal 整数值
     * @param booleanVal 布尔值
     * @param strVal 字符串值
     */
    static Do(key: CallJSSKey, intVal: number, booleanVal: boolean, strVal: string): void {
        this.log(`Do => key=${key}, intVal=${intVal}, booleanVal=${booleanVal}, strVal=${strVal}`);

        GameMsgUtil.sendMsgParent({
            type:GameMsgKey.game_do_type,
            doKey:key,
            doIntVal:intVal,
            doBooleanVal:booleanVal,
            doStrVal:strVal,
        });

        switch (key) {
            case CallJSSKey.GeoRequestFingerprint:
                // Geo.requestFingerprint(strVal);
                break;
            case CallJSSKey.GeoRequestLocation:
                // Geo.requestGeolocation(strVal);
                break;
            case CallJSSKey.GeoQueryGps:
                // Geo.queryRequestLocationPermission();
                break;
            case CallJSSKey.HideIframeDialog:
                // 实现 HideIframeDialog 逻辑（如有需要）
                break;
            case CallJSSKey.SetFrameOrientation:
                if (booleanVal){
                    GameMsgUtil.sendMsgParent({type: GameMsgKey.game_frame_horizontal});
                }else{
                    GameMsgUtil.sendMsgParent({type: GameMsgKey.game_frame_vertical});
                }
                break;
            case CallJSSKey.SetForcedLandscape:
                if (intVal === 1){
                    GameMsgUtil.sendMsgParent({type: GameMsgKey.game_frame_horizontal});
                }else{
                    GameMsgUtil.sendMsgParent({type: GameMsgKey.game_frame_vertical});
                }
                break;
            case CallJSSKey.CloseOpener:
                // 实现 CloseOpener 逻辑（如有需要）
                break;
            case CallJSSKey.HideLoading:
                // 实现 HideLoading 逻辑（如有需要）
                break;
            case CallJSSKey.ShowKeyboard:
                // 实现 ShowKeyboard 逻辑（如有需要）
                break;
            case CallJSSKey.HideKeyboard:
                // 实现 HideKeyboard 逻辑（如有需要）
                break;
            case CallJSSKey.InstallPWA:
                // Util.sendMessageToParent({ types: masterConst.OnInstallPwa, val: intVal });
                break;
            case CallJSSKey.LoadProgress:
                updateUnityBar(intVal);
                break;
            default:
                console.warn(`${this.tag} 未知的 Do key: ${key}`);
        }
    }

    /**
     * 跳转操作
     * @param key 跳转 key
     * @param strValue 字符串值
     * @param intValue 整数值
     * @returns 是否成功
     */
    static Jump(key: CallJSSKey, strValue: string, intValue: number): boolean {
        this.log(`Jump => key=${key}, strValue=${strValue}, intValue=${intValue}`);

        switch (key) {
            case CallJSSKey.JumpEmail:

                break;
            case CallJSSKey.JumpUrl:

                break;
            case CallJSSKey.Url:
                FrameOrientMgr.UpdateOrientation();
                break;
            default:
                console.warn(`${this.tag} 未知的 Jump key: ${key}`);
        }
        return false;
    }

    /**
     * 设置特定值或执行操作
     * @param key 方法名/协议名
     * @param intStr 整数或字符串值
     * @param booleanValue 布尔值
     * @param strVal1 字符串值1
     * @param strVal2 字符串值2
     */
    static Set(key: CallJSSKey, intStr: number | string, booleanValue: boolean, strVal1: string, strVal2: string): void {
        this.log(`Set => key=${key}, intStr=${intStr}, booleanValue=${booleanValue}, strVal1=${strVal1}, strVal2=${strVal2}`);

        let attr: Record<string, any> = {};

        switch (key) {
            case CallJSSKey.TrackChannel:
            case CallJSSKey.TrackThirdChannel:
                // SdkTrack.trackThirdChannel(strVal1, strVal2);
                break;
            case CallJSSKey.TrackGA4:
                // SdkTrack.trackGA4Event(strVal1, strVal2);
                break;
            case CallJSSKey.TrackFirebaseEvent:
                // SdkTrack.trackGA4Event(strVal1, { "USD": strVal2 });
                // SdkTrack.trackPixelEvent(strVal1, { currency: "USD", value: strVal2 });
                break;
            case CallJSSKey.TrackPixel:
                // SdkTrack.trackPixelEvent(strVal1, strVal2);
                break;
            case CallJSSKey.TrackAdjust:
                // SdkTrack.trackAdjust1(strVal1, strVal2);
                break;
            case CallJSSKey.Track:
                try {
                    attr = JSON.parse(strVal2);
                    const maps = new Map(Object.entries(attr));
                    // SdkTrack.track513Commit(strVal1, null, null, maps);
                } catch (error) {
                    console.error(`${this.tag} track 的 JSON 无效:`, error);
                }
                break;
            case CallJSSKey.WebDB:
                // DBMgr.UpdateData(strVal1, strVal2);
                break;
            default:
                console.warn(`${this.tag} 未知的 Set key: ${key}`);
        }
    }

    /**
     * 检查特定条件
     * @param key 检查 key
     * @param intValue 整数值
     * @param strValue 字符串值
     * @returns 布尔值
     */
    static Is(key: CallJSSKey, intValue?: number, strValue?: string): boolean {
        this.log(`Is => key=${key}, intValue=${intValue}, strValue=${strValue}`);

        switch (key) {
            case CallJSSKey.Tsetsi:
                return Util.isTestMode;
            case CallJSSKey.Golsi:
                return Util.isLog;
            case CallJSSKey.Development:
                return Util.isTestMode;
            case CallJSSKey.IsInstalledPwa:
                return KitPwa.isInstalled || KitPwa.isPlayPwa;
            case CallJSSKey.IsPlayPwa:
                return KitPwa.isPlayPwa;
            case CallJSSKey.IsDesktop:
                return UtilBrowser.isDesktop;
            case CallJSSKey.IsIOS:
                return Util.isIOS || UtilBrowser.isSafari;
            case CallJSSKey.IsAndroid:
                return Util.isAndroid;
            case CallJSSKey.IsGuidePwa:
                return confJson.h5_mode === 1;
            case CallJSSKey.IsUserBuy:
                return true;
            case CallJSSKey.OpenMoney://todo 网赚开关
                return true;

            // case CallJSSKey.WebDBOpen:
            //     return false;
            // case CallJSSKey.IsGeoReady:
            //     return DataMgr.getStorage(fwkConst.GEO_ISREADY) === '1';
            // case CallJSSKey.IsGeoOpen:
            //     // return Geo.open;
            //     return false; // 临时返回值，需根据实际情况实现
            // case CallJSSKey.IsGpsPermiReady:
            //     // return Geo.gpsPermissions.isReady;
            //     return false; // 临时返回值，需根据实际情况实现
            // case CallJSSKey.IsGpsPermiOpen:
            //     // return Geo.gpsPermissions.open;
            //     return false; // 临时返回值，需根据实际情况实现
            default:
                console.warn(`${this.tag} 未知的 Is key: ${key}`);
                return false;
        }
    }

    /**
     * 获取字符串值
     * @param key 获取 key
     * @param intValue 整数值å
     * @param strValue 字符串值
     * @returns 字符串
     */
    static GetString(key: CallJSSKey, intValue?: number, strValue?: string): string {
        this.log(`GetString => key=${key}, intValue=${intValue}, strValue=${strValue}`);

        let back: string = "";
        switch (key) {
            case CallJSSKey.GameInitJson:
                const initConfig = new GameInitConfig();
                back =  initConfig.toString();
                break;
            case CallJSSKey.Header:
                back = CallTempData.getHeaderStr;
                break;
            case CallJSSKey.Config:
                back = JSON.stringify(confJson);
                break;
            case CallJSSKey.productId:
                back = `${confJson.productId}`;
                break;
            case CallJSSKey.releaseProductId:
                back = `${confJson.releaseProductId}`;
                break;
            case CallJSSKey.GetSMID:
                back = DuMgr.SMID;
                break;
            case CallJSSKey.GetSdkCfgStr:
                if (strValue == "game_api_url")
                    back = confJson.game_api_url;
                break;
            case CallJSSKey.PlayerLevel://todo 玩家等级
                return '0';
            case CallJSSKey.VipLevel://todo 玩家等级
                return '1';
            case CallJSSKey.TimeZone://todo 时区
                return LoginUIManager.getLastUserAreaCode;
            case CallJSSKey.forceHorizontal://todo 强制横屏
                return '1';//

            // case CallJSSKey.GetAdjustAttr:
            //     back = AdjustMgr.getAdjustAttrObj;
            //     break;
            // case CallJSSKey.GetSystemLanguage:
            //     back = UtilBrowser.getLanguage;
            //     break;
            // case CallJSSKey.GetSystemCountry:
            //     back = UtilBrowser.getSystemCountry;
            //     break;
            // case CallJSSKey.GetSystemVersion:
            //     back = UtilBrowser.getOsVersion;
            //     break;
            // case CallJSSKey.GetDeviceModelName:
            //     back = UtilBrowser.getBrowserVersion;
            //     break;
            // case CallJSSKey.GetDeviceBrand:
            //     back = UtilBrowser.getBrowserName;
            //     break;
            case CallJSSKey.GaId:
            case CallJSSKey.GetWebUUID:
            case CallJSSKey.WebId:
                back = "0";//AdjustMgr.getWebUUID;
                break;
            // case CallJSSKey.H5AppName:
            //     back = confJson.h5_app_name;
            //     break;
            // case CallJSSKey.H5PackageName:
            //     back = confJson.h5_package_name;
            //     break;
            // case CallJSSKey.H5VersionName:
            //     back = confJson.h5_version_name;
            //     break;
            // case CallJSSKey.H5VersionCode:
            //     back = confJson.h5_version_code.toString();
            //     break;
            // case CallJSSKey.H5Mode:
            //     back = confJson.h5_mode.toString();
            //     break;
            // case CallJSSKey.WebDB:
            //     back = "";
            //     break;
            // case CallJSSKey.GetGeoEncrypt:
            //     // back = Geo.geoInfo.encryptStr;
            //     break;
            // case CallJSSKey.GetGeoLocation:
            //     // try {
            //     //     const geoStr = DataMgr.getStorage(kitConst.GEO_LOCATION_DECRYPT);
            //     //     if (geoStr) {
            //     //         back = JSON.stringify(geoStr);
            //     //     }
            //     // } catch (e) {
            //     //     console.error(`${this.tag} 获取 GeoLocation 时出错:`, e);
            //     // }
            //     break;
            // case CallJSSKey.GetGpsPermiState:
            //     // back = Geo.gpsPermissions.state;
            //     break;
            // default:
            //     console.warn(`${this.tag} 未知的 GetString key: ${key}`);
        }

        this.log(`GetString2 => key=${key}, back=${back}`);

        return back;
    }

    /**
     * 获取整数值
     * @param key 获取 key
     * @param intValue 整数值
     * @param strValue 字符串值
     * @returns 整数
     */
    static GetInt(key: CallJSSKey, intValue?: number, strValue?: string): number {
        this.log(`GetInt => key=${key}, intValue=${intValue}, strValue=${strValue}`);
        let back: number = 0;
        switch (key)
        {
            case CallJSSKey.GetSdkCfgInt:
                if (strValue == "releaseProductId")
                    back = confJson.releaseProductId;
                break;
            case CallJSSKey.productId:
                back = confJson.productId;
                break;
            case CallJSSKey.releaseProductId:
                back = confJson.releaseProductId;
                break;
        }

        this.log(`GetInt2 => key=${key}, back=${back}`);
        // 根据需要实现逻辑
        return back;
    }

    /**
     * 获取浮点数值
     * @param key 获取 key
     * @param intValue 整数值
     * @param strValue 字符串值
     * @returns 浮点数
     */
    static GetFloat(key: CallJSSKey, intValue?: number, strValue?: string): number {
        this.log(`GetFloat => key=${key}, intValue=${intValue}, strValue=${strValue}`);
        // 根据需要实现逻辑
        return 0;
    }
}


